import react from "react";
import Hero from "./Hero";
import PartnersInfo from "./PartnersInfo";

function PartnersPage() {
  return (
    <>
      <Hero />
      <PartnersInfo />
    </>
  );
}

export default PartnersPage;
